import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { GoogleOAuthProvider, GoogleLogin } from "@react-oauth/google";

const SignUp: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [domain, setDomain] = useState<string>("");
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  // Extract companyId from query parameters
  const queryParams = new URLSearchParams(location.search);
  const companyId = queryParams.get("companyId");

  useEffect(() => {
    if (companyId) {
      const fetchCompanyDomain = async () => {
        try {
          const response = await fetch(`https://d2q95isnao7wof.cloudfront.net/api/companies/getallcompanies/${companyId}`);
          const data = await response.json();
          if (data.website) {
            const url = new URL(data.website);
            setDomain(url.hostname.replace("www.", "")); // Extract domain from website
          }
        } catch (error) {
          console.error("Error fetching company domain:", error);
        }
      };

      fetchCompanyDomain();
    }
  }, [companyId]);

  const handleSignUp = async (e: React.FormEvent) => {
    e.preventDefault();
    const email = `${username}@${domain}`;

    try {
      const response = await fetch("https://d2q95isnao7wof.cloudfront.net/api/signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email, password }),
      });

      if (response.ok) {
        alert("Account created successfully!");
        navigate("/login"); // Redirect to login page
      } else {
        const error = await response.json();
        alert(error.message || "Failed to create account.");
      }
    } catch (error) {
      console.error("Error during sign-up:", error);
      alert("An error occurred. Please try again.");
    }
  };

  const handleGoogleLogin = async (credentialResponse: any) => {
    try {
      const response = await fetch("https://d2q95isnao7wof.cloudfront.net/api/users/google-signup", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          token: credentialResponse.credential,
          companyId, // Send the companyId to the backend
        }),
      });

      const result = await response.json();

      if (response.ok) {
        alert(
          `Account created successfully! Company domain matched.\nCompany: ${result.user.companyName}`
        );
        navigate("/login"); // Redirect to login page
      } else {
        alert(
          `Failed to create account: ${result.message}\nYour Email Domain: ${result.emailDomain}\nExpected Company Domain: ${result.companyDomain}`
        );
      }
    } catch (error) {
      console.error("Error during Google sign-up:", error);
      alert("An error occurred. Please try again.");
    }
  };

  return (
    <GoogleOAuthProvider clientId="1032489233932-a16n09q9722neubdqlgct67m229gvec0.apps.googleusercontent.com">
      <div className="min-h-screen flex items-center justify-center bg-gray-100">
        <form
          onSubmit={handleSignUp}
          className="bg-white p-8 rounded shadow-md w-96 space-y-6"
        >
          <h1 className="text-2xl font-bold text-center text-yellow-600">
            Sign Up
          </h1>

         

          <div>
            <label htmlFor="email" className="block text-gray-700 font-medium">
              Company Domain
            </label>
            <input
              id="email"
              type="text"
              value={`@${domain}`}
              disabled
              className="mt-2 p-3 w-full border rounded bg-gray-200"
            />
          </div>

        
            


       

          <GoogleLogin
            onSuccess={handleGoogleLogin}
            onError={() => alert("Google login failed. Please try again.")}
          />
        </form>
      </div>
    </GoogleOAuthProvider>
  );
};

export default SignUp;
